import { arrayOf, bool, shape, string } from 'prop-types';
import { Field } from 'react-final-form';

import { Box, FieldError, Label, SelectFilter } from '@olist/united';

import { getErrors } from './input-label-error';

const SelectLabelError = ({ initialErrors, label, name, options, showMessages, ...rest }) => (
  <Field {...rest} name={name}>
    {({ input, meta }) => {
      const errors = getErrors(meta, initialErrors[input.name]);
      const hasErrors = !!errors;

      return (
        <>
          <Label htmlFor={input.name}>{label}</Label>
          <SelectFilter
            {...rest}
            {...input}
            onOptionChange={(option) => !!option && input.onChange(option.value)}
            onInputBlur={input.onBlur}
            onInputFocus={input.onFocus}
            options={options}
            error={hasErrors}
            id={input.name}
          />
          {showMessages && hasErrors && (
            <Box mt={2}>
              <FieldError messages={errors} />
            </Box>
          )}
        </>
      );
    }}
  </Field>
);

SelectLabelError.defaultProps = {
  initialErrors: {},
  showMessages: true,
};

SelectLabelError.propTypes = {
  initialErrors: arrayOf(string),
  label: string.isRequired,
  name: string.isRequired,
  options: arrayOf(
    shape({
      label: string.isRequired,
      value: string.isRequired,
    })
  ).isRequired,
  showMessages: bool,
};

export default SelectLabelError;
